import React, {createContext, useEffect, useState} from "react";
import Firebase from "firebase/app";
import "firebase/firestore";
import {useDocumentData} from "react-firebase-hooks/firestore";
import CalendarEvent from "../../Models/CalendarEvent";
export const CalendarContext  = createContext(undefined);

export const CalendarProvider = (props: any) => {

    const [calendarData] = useDocumentData<any>(
        Firebase.firestore().collection("Calendar").doc("Events")
    );
    const [calendars, setCalendars] = useState();

    const convertCalendar = (calendarsData: any): any => {
        const convertedCalendars: any = {};

        for (const calendar in calendarsData) {
            convertedCalendars[calendar] = calendarsData[calendar].map((event: any): CalendarEvent => ({
                title: event.title, //host: event.customFields[0].value, commented this out checking app
                description: event.description,
                startDate: event.startDateTime + event.startTimeZoneOffset,
                endDate: event.endDateTime + event.endTimeZoneOffset,
                location: event.location,
                image: event.eventImage?.url,
                featured: event.categoryCalendar == "Advertised Events",
                id: event.eventID,
                addURL: event.eventActionUrl,
            }));
        }

        return convertedCalendars;
    }

    useEffect(() => {
        if (calendarData) {
            const convertedCalendar = convertCalendar(calendarData);
            setCalendars(convertedCalendar);
        }
    }, [calendarData])

    return (
        <CalendarContext.Provider value={calendars}>
            {props.children}
        </CalendarContext.Provider>
    );
};
